var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.83334L21.5 2.50001M21.5 2.50001H15.1666M21.5 2.50001L12 12M9.88889 2.5H7.56667C5.79317 2.5 4.90642 2.5 4.22903 2.84515C3.63318 3.14875 3.14875 3.63318 2.84515 4.22903C2.5 4.90642 2.5 5.79317 2.5 7.56667V16.4333C2.5 18.2068 2.5 19.0936 2.84515 19.771C3.14875 20.3668 3.63318 20.8513 4.22903 21.1549C4.90642 21.5 5.79317 21.5 7.56667 21.5H16.4333C18.2068 21.5 19.0936 21.5 19.771 21.1549C20.3668 20.8513 20.8513 20.3668 21.1549 19.771C21.5 19.0936 21.5 18.2068 21.5 16.4333V14.1111",
    stroke: "#2C67F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.78136265f4eb3c7bceca47bc3ef560f0.svg";
export { ForwardRef as ReactComponent };